import SwiperCore from '../../../../../node_modules/swiper/core/core.js';

function init() {
    const settings = {
        watchSlidesVisibility: true,
        slidesPerView: 'auto',
        watchOverflow: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            671: {
                slidesPerView: 'auto',
            }
        },
    };

    const slider = new SwiperCore('.js_oraGallery', settings);
}

$(document).ready(init);
